import "./styles.css";

export const Footer = () => (
  <footer className="footer">
    <div className="footer-container">
      <p className="footer-text">© 2026 OUTFRONT Media Inc.</p>
      <a href="https://out.media/payment-portal-guide" className="footer-link">
        Payment Portal Guide
      </a>
      <a href="https://out.media/payment-portal-video" className="footer-link">
        Payment Portal Video
      </a>
      <nav className="footer-nav">
        <a href="https://www.outfront.com/privacy" className="footer-link">
          Privacy Policy
        </a>
        <a href="https://www.outfront.com/privacy#Table2" className="footer-link">
          Cookie Policy
        </a>
        <a href="https://www.outfront.com/terms-of-use" className="footer-link">
          Terms of Use
        </a>
        <a href="https://www.outfront.com/posting-standards" className="footer-link">
          Posting Standards 
        </a>
      </nav>
    </div>
  </footer>
);
